import React from 'react';
import { useTheme } from 'styled-components';
import { ChevronUp as ChevronUpSvg } from 'src/assets/dynamicSvg';
import { ChevronDown as ChevronDownSvg } from 'src/assets/dynamicSvg';

interface Props {
  active?: boolean;
}

export const ChevronUp: React.FC<Props> = ({ active }) => {
  const activeColor = useTheme().colors.prussianBlue;
  return <ChevronUpSvg color={active ? activeColor : undefined} />;
};

export const ChevronDown: React.FC<Props> = ({ active }) => {
  const activeColor = useTheme().colors.prussianBlue;
  return <ChevronDownSvg color={active ? activeColor : undefined} />;
};
